module.exports = __webpack_public_path__ + "img/visitor-color.ccfe4a7c.png";